export const Countries = {
    "Australia": "au",
    "Albania": "al",
    "Algeria": "dz",
    "Andorra": "ad",
    "Angola": "ao",
    "Argentina": "ar",
    "Canada": "ca",
    "China": "cn",
    "France": "fr",
    "Finland": "fi",
    "Germany": "de",
    "India": "in",
    "Italy": "it",
    "Japan": "jp",
    "Nepal": "np",
    "New zealand":"nz",
    "Pakistan": "pk",
    "Russia": "ru",
    "Singapore": "sg",
    "South Africa": "za",
    "Sri Lanka": "lk",
    "United Kingdom": "gb",
    "United States": "us",
    "Ukraine": "ua",
    "World": "wo",
}

export const Language = {
    // "Afrikaans": "af",
    // "Albanian": "sq",
    // "Amharic": "am",
    // "Arabic": "ar",
    // "Armenian": "hy",
    // "Assamese": "as",
    // "Azerbaijani": "az",
    // "Bambara": "bm",
    // "Basque": "eu",
    // "Belarusian": "be",
    "Bengali": "bn",
    // "Bosnian": "bs",
    // "Bulgarian": "bg",
    // "Burmese": "my",
    // "Catalan": "ca",
    // "Central Kurdish": "ckb",
    // "Chinese": "zh",
    // "Croatian": "hr",
    // "Czech": "cs",
    // "Danish": "da",
    // "Dutch": "nl",
    "English": "en",
    // "Estonian": "et",
    // "Filipino": "pi",
    // "Finnish": "fi",
    // "French": "fr",
    // "Galician": "gl",
    // "Georgian": "ka",
    // "German": "de",
    // "Greek": "el",
    "Gujarati": "gu",
    // "Hausa": "ha",
    // "Hebrew": "he",
    "Hindi": "hi",
    // "Hungarian": "hu",
    // "Icelandic": "is",
    // "Indonesian": "id",
    // "Italian": "it",
    // "Japanese": "jp",
    "Kannada": "kn",
    // "Kazakh": "kz",
    // "Khmer": "kh",
    // "Kinyarwanda": "rw",
    // "Korean": "ko",
    // "Kurdish": "ku",
    // "Latvian": "lv",
    // "Lithuanian": "lt",
    // "Luxembourgish": "lb",
    // "Macedonian": "mk",
    // "Malay": "ms",
    "Malayalam": "ml",
    "Maltese": "mt",
    // "Maori": "mi",
    "Marathi": "mr",
    // "Mongolian": "mn",
    "Nepali": "ne",
    // "Norwegian": "no",
    // "Oriya": "or",
    // "Pashto": "ps",
    // "Persian": "fa",
    // "Polish": "pl",
    // "Portuguese": "pt",
    "Punjabi": "pa",
    // "Romanian": "ro",
    // "Russian": "ru",
    // "Samoan": "sm",
    // "Serbian": "sr",
    // "Shona": "sn",
    // "Sindhi": "sd",
    // "Sinhala": "si",
    // "Slovak": "sk",
    // "Slovenian": "sl",
    // "Somali": "so",
    // "Spanish": "es",
    // "Swahili": "sw",
    // "Swedish": "sv",
    // "Tajik": "tg",
    "Tamil": "ta",
    "Telugu": "te",
    // "Thai": "th",
    // "Traditional chinese": "zht", 
    // "Turkish": "tr",
    // "Turkmen": "tk",
    // "Ukrainian": "uk",
    // "Urdu": "ur",
    // "Uzbek": "uz",
    // "Vietnamese": "vi",
    // "Welsh": "cy",
    // "Zulu": "zu"
}

export const Categories = [
    "For you",
    "business", "crime", "domestic", "education", "entertainment", "environment",
    "food", "health", "lifestyle", "other", "politics", "science", "sports",
    "technology", "top", "tourism", "world"
  ];

  export const LanguageToVoiceMap = {
    bengali: "Bengali Female",
    english: "US English Female", 
    gujarati: "Gujarati Female",
    hindi: "Hindi Female",
    kannada: "Kannada Female",
    malayalam: "Malayalam Female",
    maltese: "Maltese Female",
    marathi: "Marathi Female",
    nepali: "Nepali Female",
    punjabi: "Punjabi Female",
    tamil: "Tamil Female",
    telugu: "Telugu Female",
  };